import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetServicingV1AccountsLenderAccountIdentifierBankAccountsQuery } from 'servicing-api';
import { isActiveBankAccount } from '../../utils';
/** The account's bank accounts that can still be charged, plus whether the list has loaded. */
function useActiveBankAccounts(lenderAccountIdentifier) {
    const { data, isSuccess, isError, isFetching, refetch } = useGetServicingV1AccountsLenderAccountIdentifierBankAccountsQuery(lenderAccountIdentifier ? { lenderAccountIdentifier } : skipToken, { refetchOnMountOrArgChange: true });
    const bankAccounts = useMemo(() => (data ?? []).filter(isActiveBankAccount), [data]);
    return {
        bankAccounts,
        isResolved: (isSuccess || isError) && !isFetching,
        hasLoadError: isError && !isFetching,
        refetch,
    };
}
export default useActiveBankAccounts;
